:host {
  --search-input-height: 54px;
  --font-family: var(--font-family-secondary);
  min-width: var(--dropdown-list-width);
  background: var(--white-layout-302-level-1-elevation);
  --display-search-on-loading: none;
  --spinner-margin: unset;
  --spinner-size-transform: scale(1.5);
  --search-width: 100%;
  --search-top: 0;
}

.list {
  overflow: auto;
  display: flex;
  flex-direction: column;
  height: 100%;

  &--search {
    padding: calc(1.5 * var(--spacer));
  }

  &--title {
    padding: var(--spacer);
  }

  &--options {
    flex: 1;
    overflow: auto;

    .option-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 calc(var(--spacer) * 1.5);
      width: 100%;
      line-height: 18px;
      height: calc(4 * var(--spacer));
      cursor: pointer;
      color: var(--main-titles-inputs-600);

      &[disabled] {
        color: var(--grey-layout-200-disabled);
      }

      &.hidden {
        display: none;
      }

      &:hover {
        background-color: var(--chart-051-hover);
      }

      &.active {
        background-color: var(--blue-layout-050-selected);
      }

      &:active {
        background-color: var(--chart-100-pressed);
      }
    }
  }

  &--no-results {
    text-align: center;
    padding: calc(var(--spacer) * 3) 0;
    display: none;
    background-color: var(--white-layout-301-level-0-elevation);

    &.visible {
      display: block;
      color: var(--main-titles-inputs-600);
      background: transparent;
    }
  }
}

.list-group {
  border-bottom: 1px solid var(--chart-100-pressed);

  &--title {
    color: var(--chart-302-icon-buttons-titles);
    padding: var(--spacer) calc(var(--spacer) * 1.5);
  }

  &:has(+ #emptyTemplate),
  &:last-of-type {
    border-bottom: none;
  }
}

.spinner {
  display: flex;
  justify-content: center;
  padding: var(--spacer) calc(var(--spacer) * 2) var(--spacer) var(--spacer);
  margin: var(--spinner-margin);

  gz-progress-spinner {
    width: fit-content;
    display: flex;
    transform: var(--spinner-size-transform);
  }
}

:host(.single-select-list) {
  .list {
    max-height: var(--single-select-list-content-max-height);

    &--search {
      display: none;
      position: absolute;
      width: var(--search-width);
      height: var(--search-input-height);
      top: var(--search-top);
    }

    &.has-search {
      padding-top: var(--search-input-height);

      .list {
        &--search {
          display: block;
          background: var(--white-layout-301-level-0-elevation);
        }
        &--options {
          background: var(--white-layout-301-level-0-elevation);
        }
      }
    }
  }
}

:host([isLoading]) {
  .list {
    &.has-search {
      padding-top: initial;
      background: var(--white-layout-301-level-0-elevation);
    }

    &--search {
      display: var(--display-search-on-loading) !important;
    }
  }
}

:host([filterOptions='[]']) #emptyTemplate {
  display: block !important;
}
